import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFileAlt from '@fortawesome/fontawesome-free-regular/faFileAlt';
import faTrash from '@fortawesome/fontawesome-free-solid/faTrashAlt';
import formPropsType from '../../../common/types/formPropsType';
import Button from '../../../../components/common/Button';

import './Services.css';

class AttachmentLineItem extends Component {
  render() {
    const { attachment, formProps, onDeleteAttachment } = this.props;

    return (
      <div style={{ flex: 1, margin: '2px 0 2px 0' }} className="field is-grouped">
        <div className="control is-expanded">
          <a href={attachment.path} target="_blank">
            <FontAwesomeIcon icon={faFileAlt} /> {attachment.originalFileName}
          </a>
        </div>
        <Button
          size="small"
          type="button"
          color="danger"
          handler={() => {
            onDeleteAttachment(attachment);
          }}
          title="Delete this attachment"
          isDisabled={formProps.isSubmitting}
          label={
            <FontAwesomeIcon icon={faTrash} className="icon" fixedWidth />}
        />
      </div>
    );
  }
}

AttachmentLineItem.propTypes = {
  formProps: formPropsType.isRequired,
  onDeleteAttachment: PropTypes.func.isRequired,
  attachment: PropTypes.element.isRequired,

};

export default AttachmentLineItem;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/AttachmentLineItem.jsx